//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    price: { type: Number, required: true },
    discount: { type: Number, default: 0 },
    isMinimumPrice: { type: Boolean, default: false },
    size: { type: String, validator: val => ['regular', 'small'].includes(val), default: 'regular' }
  },
  computed: {
    priceSize () {
      return {
        regular: 'h3',
        small: 'h4'
      }[this.size]
    }
  }
}
